import React, { useState } from "react";

// APP COMPONENTS
import { fiscalCodeRegistered } from "../../common/frames";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const HasFiscalFilter = ({ selectedValue, onFilterChange }) => {
  const [types, setTypes] = useState(fiscalCodeRegistered);

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="has-fiscal-options-values"
      options={types}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Código NCM Cadastrado?"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

HasFiscalFilter.displayName = "NCM";

export default HasFiscalFilter;
